import { ChallengeDto } from '../../dto/auth';
import { Expose, Type } from 'class-transformer';
import { IsOptional } from 'class-validator';

export class LoginResponseDto {
    @Expose()
    @IsOptional()
    authChallengeToken?: string;

    @Expose()
    @IsOptional()
    accessToken?: string;

    @Expose()
    @IsOptional()
    refreshToken?: string;

    @Expose()
    @IsOptional()
    @Type(() => ChallengeDto)
    challenge?: ChallengeDto;
}
